<template>
  <div>
    <slot></slot>
    <div class="mt-8 flex w-full justify-end flex-col-reverse md:flex-row">
      <vue-button @click="handleReset" class="mr-2 btn btn-gray btn-outline w-full md:w-auto md:mr-2">Réinitialiser</vue-button>
      <vue-button @click="handleConfirm" class="btn btn-primary w-full md:w-auto mb-2 md:mb-0">Valider</vue-button>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    paramsToReset() {
      return [
        ...this.$children
          .map((component) => {
            const options = component.$options;
            // eslint-disable-next-line no-underscore-dangle
            return options._componentTag.includes('vue-filter') &&
              options.propsData
              ? component.$options.propsData.param
              : null;
          })
          .filter(value => value),
        'page',
      ];
    },
  },

  methods: {
    handleConfirm() {
      Event.fire('refreshCollection');
      this.$emit('applied');
    },

    handleReset() {
      const params = new URLSearchParams(window.location.search);
      this.paramsToReset.forEach(param => params.delete(param));
      history.pushState(null, '', `?${params.toString()}`);
      this.handleConfirm();
    },
  },
};
</script>
